
import React, { useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import Slider from "react-slick"
import TextContent from "../TextContent/TextContent"
import PropTypes from "prop-types"
import { get, getLocDets, getFuncName } from "../../helpers/utils"
import Link from "../UI/Link/Link"
import Typography from "../UI/Typography/Typography"
import * as styles from "./BlockSlider-tw-styles"
import NewsStoryCards from "../NewsStoryCard/NewsStoryCard"
import MultiColumnGridWithTextOrLink from "../MultiColumnGridWithTextOrLink/MultiColumnGridWithTextOrLink"
import {
  NewsStoryCard,
  TextCards,
  jobFamily,
  countryList,
} from "../../constants/label.constants"
import ProductSlider from "../ProductSlider/ProductSlider"
import StockSlider from "../StockSlider/StockSlider"
import { getAllJobs } from "../../redux/actions/jobListActions"
import useStaticData from "./StaticComponents"
import { labels } from "../../constants/label.constants"
import Image from "../UI/Image/Image"
import useScreenSize from "../../hooks/useScreenSize"
const { countryJobLocation } = require("../../service/CountryJobLocation")

const CustomButton = props => {
  const { className, style, onClick, eventLabel } = props

  return (
    <div
      role="button"
      className={`${className} event_slider`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
      data-action-detail={eventLabel}
      aria-label={eventLabel}
    />
  )
}
CustomButton.propTypes = {
  className: PropTypes.string,
  eventLabel: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

const BlockSlider = props => {
  const {
    title,
    hasJobData,
    JobsToShow = 10,
    countryFilter,
    jobFamilyFilter,
    countryCode,
    contentSliceCollection,
    slidesCollection,
    link,
    slidesToShowOnDesktop,
    variant,
    description,
    elementId = "",
    textContent = {},
    cameoImages = {}
  } = props

  const slidesToShowOnDesktopNew = slidesToShowOnDesktop
    ? slidesToShowOnDesktop
    : 3

  let convertedUrl = !link?.url?.includes(".")
    ? link?.url?.toLowerCase()
    : link?.url
  if (link?.url?.includes("?")) {
    const url = link?.url?.split("?")
    convertedUrl = url[0]?.toLowerCase().concat("?").concat(url[1])
  }
  const screen = useScreenSize()

  const cameoImagesCollection = screen?.isMobile
  ? [cameoImages?.cameoMediumMobile, cameoImages?.cameoLargeMobile]
  : [cameoImages?.cameoMedium, cameoImages?.cameoLarge]

  const slides = slidesCollection && get(slidesCollection, "items", []);
  var contentSlices;
  if (variant === "COMMUNITY_INITIATIVES_SLIDER") {
    contentSlices = contentSliceCollection && get(contentSliceCollection, "items", [])
  }

  const hasImagesWithText = variant === "NEWS_STORY_CARDS" ? true : false
  const hasJobSlider = variant === "JOB_SLIDER" ? true : false
  const dispatch = useDispatch()
  const style = styles[variant] || styles["defaultStyle"]
  let staticData = useStaticData()
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };

  const { jobListReducer } = useSelector(state => state)
  const { jobRes } = jobListReducer
  const { hits = [] } = jobRes
  let latestJobs = hits?.length > 0 ? hits?.slice(0, JobsToShow) : []
  let selectedFilters = {
    selectedLocations: "",
    jobType: "",
    jobFamily: "",
    timeType: "",
    earlyCareers: "",
  }

  if (hasJobData && countryFilter) {
    let result = countryList.filter(
      item => item.label.toLowerCase() === countryFilter.toLowerCase()
    )
    selectedFilters = {
      ...selectedFilters,
      selectedLocations: result[0]?.selectedLocations,
    }
  } else if (hasJobData && jobFamilyFilter) {
    let result = jobFamily.filter(
      item => item.label.toLowerCase() === jobFamilyFilter.toLowerCase()
    )
    selectedFilters = {
      ...selectedFilters,
      jobFamily: result[0]?.value,
    }
  }
  const checkSlidesAndTotalSlides = () => {
    if (
      (hasJobData && latestJobs?.length < 3) ||
      (!hasJobData && slides?.length < 3 && variant != "STOCK_SLIDER")
    ) {
      return false
    } else if (
      (hasJobData && latestJobs?.length > 3) ||
      (!hasJobData && slides?.length > 3)
    ) {
      return true
    } else if (variant == "STOCK_SLIDER") {
      return true
    }
  }

  const settings = {
    dots: true,
    arrows: true,
    swipe: false,
    draggable: true,
    variableWidth: true,
    infinite: checkSlidesAndTotalSlides(),
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: slidesToShowOnDesktopNew,
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (
      <CustomButton className={style?.prevArrow} eventLabel="Next Arrow" />
    ),
    prevArrow: (
      <CustomButton className={style?.nextArrow} eventLabel="Prev Arrow" />
    ),
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: hasJobSlider ? 2 : 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: hasJobSlider ? 2 : 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.1,
          dots: true,
        },
      },
    ],
  }
  
  const awardSetttings ={
    dots: true,
    arrows: false,
    swipe: false,
    draggable: true,
    variableWidth: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'ease-in-out',
    speed: 1000,
    slidesToShow: slidesToShowOnDesktopNew,
    slidesToScroll: 3,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  }
  const otherInitiativesSetttings ={
    dots: true,
    arrows: true,
    swipe: true,
    draggable: true,
    variableWidth: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (
      <CustomButton className={style?.prevArrow} eventLabel="Next Arrow" />
    ),
    prevArrow: (
      <CustomButton className={style?.nextArrow} eventLabel="Prev Arrow" />
    ),
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  }
  const communityInitiativesSetttings ={
    dots: true,
    arrows: false,
    swipe: false,
    draggable: true,
    variableWidth: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (
      <CustomButton className={style?.prevArrow} eventLabel="Next Arrow" />
    ),
    prevArrow: (
      <CustomButton className={style?.nextArrow} eventLabel="Prev Arrow" />
    ),
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
        },
      },
    ],
  }

  const cocoaLifeSetttings ={
    dots: true,
    arrows: true,
    swipe: true,
    draggable: true,
    variableWidth: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (
      <CustomButton className={style?.prevArrow} eventLabel="Next Arrow" />
    ),
    prevArrow: (
      <CustomButton className={style?.nextArrow} eventLabel="Prev Arrow" />
    ),
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  }

  const buildJobSlides = () => {
    return (
      latestJobs?.length > 0 &&
      latestJobs?.map((item, idx) => {
        let jobId =
          item?.Job_Requisition_ID?.length > 0 && item?.Job_Requisition_ID[0]
        let jobPostingDate =
          item?.Job_Posting_Start_Date &&
          new Date(item?.Job_Posting_Start_Date).toLocaleString([], {
            weekday: "long",
            month: "long",
            day: "2-digit",
            year: "numeric",
          })
        let jobTitle =
          item?.Job_Posting_Title?.length > 0 && item?.Job_Posting_Title[0]
        let location =
          item?.Job_Posting_Location_Data?.length > 0 &&
          getLocDets(
            item?.Job_Posting_Location_Data[0],
            staticData?.contentfulJobFilter?.countriesList
          )
        let country = location?.length > 0 && location[0]?.locName
        let jobFamily =
          item?.Job_Family_Reference?.length > 0 &&
          getFuncName(
            item?.Job_Family_Reference?.length > 0 &&
              item?.Job_Family_Reference[0],
            staticData?.contentfulJobFilter?.filterData
          )

        let jobLink = {
          url: `/careers/jobs/job?jobid=${jobId}&jobtitle=${jobTitle}`,
        }
        if (item?.countryCode === "US") {
          if (labels?.Job_Profile_ID.includes(item?.Hiring_Requirement_Data[0])) {
            let jobID = item?.objectID
            var paradoxlink = {
              url: process.env.GATSBY_PARADOX_URL + jobID
            }
          }
        }
        return (
          <div className={style?.blockSlide} key={idx}>
            <p className="jobDate">
              {jobId} | {jobPostingDate}
            </p>
            {jobTitle && (item?.countryCode === "US" && labels?.Job_Profile_ID.includes(item?.Hiring_Requirement_Data[0])) 
                ? (
                    <Link {...paradoxlink} className={style?.btnWrpr}>
                      {jobTitle}
                    </Link>
                  )
                : (
                  <Link {...jobLink} className={style?.btnWrpr}>
                    {jobTitle}
                  </Link>
                )
              }
            
            {country && <p className="locationName">{country}</p>}
            {item?.Job_Posting_Location_Data?.length > 0 &&
              item?.Job_Posting_Location_Data[0]?.Additional_Location_Reference
                ?.length > 0 && (
                <span className="otherLocationName">
                  {
                    item?.Job_Posting_Location_Data[0]
                      ?.Additional_Location_Reference?.length
                  }{" "}
                  other location(s) available
                </span>
              )}
            {jobFamily && <p className="jobfamily">{jobFamily}</p>}
          </div>
        )
      })
    )
  }

  const buildContentSlices = () =>{
    return (
      contentSlices?.length > 0 &&
      contentSlices?.map((item, idx) => {
        if(item?.__typename === 'MultiColumnGridWithTextOrLink' && variant === "COMMUNITY_INITIATIVES_SLIDER"){
          return (
            <div key={item?.title} className={style?.blockSlideWrpr}>
              <div className={style?.blockSlide}>
               <MultiColumnGridWithTextOrLink {...item} variant="OUR_ROADMAP_SECTION"/>
              </div>
            </div>
          )
        }
      }
    ))
  }

  const buildSlides = () => {
    return (
      slides?.length > 0 &&
      slides?.map((item, idx) => {
        if(item?.__typename === TextCards && variant === "OTHER_INITIATIVES_SLIDER"){
          return (
            <div key={item?.title} className={style?.blockSlideWrpr}>
              <div className={style?.blockSlide}>
                <Link {...item?.link}>
                {item?.image?.imageDesktop?.url && (
                  <div className={style?.imgWrapper}>
                  <Image src={item?.image?.imageDesktop?.url} className={style?.imageDesktop}/>
                  </div>
                )}
                {item?.title && (
                  <Typography
                    className={style?.subHeading}
                    content={item?.title}
                  />
                )}</Link>
              </div>
            </div>
          )
        }
        if(item?.__typename == "MultiColumnGridWithTextOrLink" ){
          return (
            <div key={item?.title} className={style?.blockSlideWrpr}>
              <div className={style?.blockSlide}>
               <MultiColumnGridWithTextOrLink {...item} />
              </div>
            </div>
          )
        }
        if(item?.__typename === TextCards && (variant === "SUSTAINABLE_COCOA_LIFE_FARMING" || variant === "RESTORING_FORESTS") ){
          return (
            <div key={item?.title} className={style?.blockSlideWrpr}>
              <div className={style?.blockSlide}>
              <div className={style?.imgWrapper}>
              {item?.image?.imageDesktop?.url && (
                  <Image src={item?.image?.imageDesktop?.url} className={style?.imageDesktop}/>
                )}
              </div>
              <div className={style?.descriptionWrapper}>
                {item?.title && (
                  <Typography
                    className={style?.subHeading}
                    content={item?.title}
                  />
                )}
                {item?.description && (
                  <Typography
                    className={style?.description}
                    content={item?.description}
                    allow_br_tag={true}
                  />
                )}
                </div>
              </div>
            </div>
          )
        }
        if (item?.__typename === TextCards && variant !== "PRODUCT_SLIDER" && variant !== "AWARD_CARD_SLIDER") {
          return (
            <div key={item?.title} className={style?.blockSlideWrpr}>
              <div className={style?.blockSlide}>
                {item?.cardTag && (
                  <p className={style?.cardTag}>{item?.cardTag}</p>
                )}
                {item?.title && (
                  <Typography
                    className={style?.subHeading}
                    content={item?.title}
                  />
                )}
                {item?.description && (
                  <Typography
                    className={style?.description}
                    content={item?.description}
                    allow_br_tag={true}
                  />
                )}
              </div>
            </div>
          )
        } else if (item?.__typename === NewsStoryCard) {
          return <NewsStoryCards {...item} key={idx} />
        } else if(item?.__typename === TextCards && variant === "AWARD_CARD_SLIDER"){
          return (
            <div key={item?.title} className={style?.blockSlideWrpr}>
              <div className={style?.blockSlide}>
                {item?.image?.imageDesktop?.url && (
                  <Image src={item?.image?.imageDesktop?.url} className={style?.imageDesktop}/>
                )}
                     {item?.title && (
                  <Typography
                    className={style?.subHeading}
                    content={item?.title}
                  />
                )}
                {item?.description && (
                  <Typography
                    className={style?.description}
                    content={item?.description}
                    allow_br_tag={true}
                  />
                )}
              </div>
            </div>
          )
        }
      })
    )
  }

  const getJobDetails = (locationData=null) => {
    if(locationData){
      selectedFilters = {
        ...selectedFilters,
        selectedLocations: locationData,
      }
    }
    if (hasJobData) {
      dispatch(
        getAllJobs({
          ...jobListReducer,
          filtersArr: selectedFilters,
        })
      )
    }
  }

  useEffect(() => {
    if(countryCode) {
      (async () => {
        const data = await countryJobLocation(countryCode)
        const locationData = data.map(location => location.value)
        getJobDetails(locationData)
      })();     
    } else {
      getJobDetails()
    }
    const children = document.querySelectorAll(".slick-dots button")
    if (children?.length > 0) {
      ;[...children].forEach(e => {
        e?.setAttribute("class", "event_slider")
        e?.setAttribute("data-action-detail", "Dots click")
        e?.setAttribute("aria-label", "Dots click")
      })
    }
  }, [])

  return (
    <div className={style?.blockSliderFullBG} id={elementId}>
      {(latestJobs?.length || slides?.length || contentSlices?.length || variant === "STOCK_SLIDER") && (
        <div
          className={`${style?.blockSlider} ${
            checkSlidesAndTotalSlides() ? "infiniteSlider" : "noInfiniteSlider"
          }`}
        >
          {title && <h2 className={style?.heading}>{title}</h2>}
          {description && (
            <Typography className={style?.description} content={description} />
          )}
            {(cameoImages && screen?.isMobile && cameoImages?.cameoMediumMobile) ? <div className={style?.imageWrapperMedium}>
                  <Image src={cameoImages?.cameoMediumMobile?.url} /> </div> : <div className={style?.imageWrapperMedium}>
                  <Image src={cameoImages?.cameoMedium?.url} />
                </div>
            }{(cameoImages && screen?.isMobile && cameoImages?.cameoLargeMobile) ? <div className={style?.imageWrapperLarge}>
            <Image src={cameoImages?.cameoLargeMobile?.url} /> </div> : <div className={style?.imageWrapperLarge}>
            <Image src={cameoImages?.cameoLarge?.url} />
              </div>
            }

          <div role="" className={style?.blockSliderWrapper} aria-labelledby="carouselheading">
          <h3 id="carouselheading" className="hidden">{title}</h3>
            {variant === "AWARD_CARD_SLIDER"?
                 <Slider ref={slider => {
                  sliderRef = slider;
                }} {...awardSetttings}>
                {hasJobData ? buildJobSlides() : buildSlides()}
              </Slider>: (variant !== "OTHER_INITIATIVES_SLIDER" && variant !== "SUSTAINABLE_COCOA_LIFE_FARMING"  && variant !== "RESTORING_FORESTS" && <Slider {...settings}>
              {hasJobData ? buildJobSlides() : buildSlides()}
            </Slider>)
            }
             {variant === "OTHER_INITIATIVES_SLIDER" &&
                 <Slider ref={slider => {
                  sliderRef = slider;
                }} {...otherInitiativesSetttings}>
                {buildSlides()}
              </Slider>
            }
             {variant === "COMMUNITY_INITIATIVES_SLIDER" &&
                buildContentSlices()
            }
            {(variant === "SUSTAINABLE_COCOA_LIFE_FARMING" || variant === "RESTORING_FORESTS") &&
                 <Slider ref={slider => {
                  sliderRef = slider;
                }} {...cocoaLifeSetttings}>
                {buildSlides()}
              </Slider>
            }
            {variant === "AWARD_CARD_SLIDER" &&
              <div className={style?.slickArrow} style={{ textAlign: "center" }}>
                <button className="button prev" onClick={previous}>
                  Previous
                </button>
                <button className="button next" onClick={next}>
                  Next
                </button>
              </div>
            }
            
          </div>

          {link?.label && (
            <div>
              <div className={`${style?.btnContainer}`}>
                <a
                  href={convertedUrl}
                  className={`${style?.btnWrpr} event_button_click`}
                  target={link?.target}
                  aria-label={link.label}
                  data-action-detail={link?.label}
                >
                  {link?.label != "Back to top" && link?.label}
                  {link?.images && <Image src={link?.images?.imageDesktop?.url}/>}
                </a>
              </div>
            </div>
          )}
          {textContent && <TextContent {...textContent}/>}
          {variant === "PRODUCT_SLIDER" && (
            <ProductSlider slides={slides}></ProductSlider>
          )}

          {variant === "STOCK_SLIDER" && <StockSlider variant={variant} />}
        </div>
      )}
    </div>
  )
}

BlockSlider.propTypes = {
  title: PropTypes.string,
  hasJobData: PropTypes.bool,
  JobsToShow: PropTypes.number,
  countryFilter: PropTypes.string,
  countryCode: PropTypes.any,
  jobFamilyFilter: PropTypes.string,
  slidesCollection: PropTypes.object,
  link: PropTypes.object,
  variant: PropTypes.string,
  description: PropTypes.string,
  elementId: PropTypes.string,
  slidesToShowOnDesktop: PropTypes.number,
  textContent : PropTypes.object,
  cameoImages : PropTypes.object,
  contentSliceCollection:PropTypes.object,
}

export default BlockSlider